export const base64Encode = str => Buffer.from(str).toString('base64')

export const base64Decode = str => Buffer.from(str, 'base64').toString('ascii')

export const regExEscape = str => str.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')

export const capitalize = str =>
  typeof str === 'string' && str.length > 1 ? str.charAt(0).toUpperCase() + str.substring(1).toLowerCase() : str

export const isN = str => !isNaN(parseInt(str))

export const dashCase = str => (str || '').toLowerCase().replace(/\s+/g, '-')

export const errorCodeToString = code => capitalize(code?.replace(/_/g, ' ') || '')
